export const numberWithComma = (num: number) => {
  if (!num) return 0;

  return num.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
